import React, { useEffect, useState } from 'react'
import axios from 'axios';
import ThemeMaker from '../../components/thememaker'
import { DownOutlined, SettingOutlined } from '@ant-design/icons';
// import type { MenuProps } from 'antd';
import { tokenDecode } from "../../utils/helper";
import { Dropdown } from 'antd';
import { config } from "../../utils/config";
// import { Badge } from "antd";
import { Badge, Space, Switch, Modal, Input, Select } from 'antd';
import { toast } from 'react-toastify';
import { ToastContainer } from 'react-toastify';
export default function Updatepricestructure() {
    const decoded = tokenDecode();
    console.log(decoded)
    const { apiEndpoint, baseNodeapiUrl } = config
    useEffect(() => {
        getproductlist();
    }, []);
    const [productisLoading, setproductisLoading] = useState(false);
    const [productlist, setproductlist] = useState([]);
    const [allProducts, setAllproducts] = useState([]);
    console.log(productlist)
    const [selectedItems, setSelectedItems] = useState([])
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [cateogies, setcateogies] = useState([]);
    const [choosenMethod, setChoosenMethod] = useState("product");
    const [formmData, setFormData] = useState({
        flat: "",
        percent: "",
        bnp: [],
        category: []
    })
    const [serchedKey, setSearchedKey] = useState("")
    console.log(isModalOpen)
    function onSelectProduct(id) {
        let withinSelectedItems = [...selectedItems];

        const index = withinSelectedItems.findIndex(item => item?.ondc_product_id === id);

        if (index !== -1) {

            withinSelectedItems.splice(index, 1);
        } else {

            withinSelectedItems.push({ id });
        }

        setSelectedItems(withinSelectedItems);
    }
    async function getproductlist() {
        let parentId = decoded?.data?.user?.parent_id;
        let SellerId = decoded?.data?.user?.seller_id;

        let payload;
        if (parentId > 1) {
            payload = { seller_id: parentId }

        } else {
            payload = { seller_id: SellerId }
        }
        setproductisLoading(true)
        try {
            const { data } = await axios({
                url: `${apiEndpoint}/listproductsallsvar`,
                method: "POST",
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem("us_st_d")}`,
                },
                data: payload,
            });
            if (data.status === 200) {
                setproductisLoading(false)
                setcateogies(data?.data?.map(item => item?.product_type_name))
                // setItemOffset(0)
                setproductlist(data.data);
                setAllproducts(data.data);
            }
        } catch (error) {
            console.log(error);
        }
    }
    const handleChange = (value) => {
        console.log(`selected ${value}`);
        if (value !== "product") {
            // alert()
            setIsModalOpen(true);

        }
        setChoosenMethod(value)


    };




    const showModal = async () => {
        setIsModalOpen(true);
    };

    const handleOk = async () => {
        let payload;
        let urlEndpoint;
        if (choosenMethod === "provider") {
            payload = {
                provider_id: decoded?.data?.seller_data?.provider_id,
                ...formmData
            }
            urlEndpoint = "dynamic-pricing-provider"
        }

        if (choosenMethod === "product") {
            payload = selectedItems?.map(item => { return { provider_id: decoded?.data?.seller_data?.provider_id, item_id: item.id, ...formmData, } })
            urlEndpoint = "dynamic-pricing-item"
        }
        if (choosenMethod === "category") {
            payload = { provider_id: decoded?.data?.seller_data?.provider_id, ...formmData, }
            urlEndpoint = "dynamic-pricing-category"
        }
        console.log(payload)

        try {
            const data = await axios({
                url: `${apiEndpoint}/${urlEndpoint}`,
                method: "POST",
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem("us_st_d")}`,
                },
                data: payload
            })

            console.log(data)

            if (data?.data?.status === "success") {
                toast.success("Updated Successfully")
            }
        } catch (err) {
            console.log(err);
            toast.error("Something went wrong while updating")
        }

        // alert()
        setIsModalOpen(false);
        setSelectedItems([])
        setFormData({
            flat: "",
            percent: "",
            bnp: [],
            category: []
        })
    };

    const handleCancel = () => {
        setIsModalOpen(false);
        setIsModalOpen(false);
        setSelectedItems([])
        setFormData({
            flat: "",
            percent: "",
            bnp: [],
            category: []
        })
    };


    const options = [
        {
            label: 'Mystore',
            value: 'prd.mystore.in',
            emoji: '😄',
            desc: 'Feeling Good',
        },
        {
            label: 'Hamara Mall',
            value: 'ondc.nlincs.in',
            emoji: '😢',
            desc: 'Feeling Blue',
        },
        {
            label: 'Eazehub',
            value: 'moyto.eazehub.com',
            emoji: '😡',
            desc: 'Furious',
        },
        {
            label: 'Sahajbazaar',
            value: 'api.sahajbazaar.in',
            emoji: '😎',
            desc: 'Chilling',
        },

        {
            label: 'Mappls',
            value: 'mappls.com',
            emoji: '😴',
            desc: 'Need Sleep',
        },
        {
            label: 'Digihatt',
            value: 'prod.nirmitbap.ondc.org',
            emoji: '😴',
            desc: 'Need Sleep',
        },

    ];

    useEffect(() => {
        if (serchedKey !== "") {
            let allItems = [...allProducts];
            let filterededItems = allItems.filter(item => item.name.toLowerCase().includes(serchedKey.toLowerCase()))
            setproductlist(filterededItems)
        } else {
            setproductlist(allProducts)
        }
    }, [serchedKey])



    return (
        <ThemeMaker>
            <ToastContainer />
            <div className="row w-100 m-0 mt-1">
                <div className="col-md-12 ">
                    <div className="card shadow mb-4">

                        <div className="card-header py-3">
                            <h6 className='text-dark'>Configure commission price </h6>
                        </div>

                        <div className="card-body p-0" style={{ padding: "10px !important", minHeight: "70vh" }}>
                            <div className='p-3'>

                                <Space wrap>

                                    <Select
                                        value={choosenMethod}
                                        style={{ width: 200 }}
                                        onChange={handleChange}
                                        options={[
                                            { value: 'select your rule type', label: 'select your rule type', disabled: true },

                                            { value: 'category', label: 'Category' },
                                            { value: 'provider', label: 'Provider' },
                                            { value: 'product', label: 'Product' },
                                            // { value: 'disabled', label: 'Disabled', disabled: true },
                                        ]}
                                    />

                                </Space>

                            </div>

                            {choosenMethod === "product" && <><div>

                                {!productisLoading && <div className='d-flex justify-content-end p-2 align-items-center' style={{ gap: "10px" }}>
                                    <Input placeholder="Enter product name" style={{ width: "200px" }} onChange={(e) => setSearchedKey(e.target.value)} />
                                    <Badge
                                        className="site-badge-count-109"
                                        count="Select all"
                                        style={{ backgroundColor: 'lightgrey', color: "black", cursor: "pointer" }}
                                        onClick={() =>
                                            setSelectedItems(productlist?.map(item => ({ id: item?.ondc_product_id })))
                                        }
                                    />

                                    {selectedItems?.length > 0 && <Badge
                                        className="site-badge-count-109"
                                        count="Cancel"
                                        style={{ backgroundColor: 'lightgrey', color: "black", cursor: "pointer" }}
                                        onClick={() =>
                                            setSelectedItems([])
                                        }
                                    />}
                                </div>}
                                {!productisLoading && <div className='d-flex flex-wrap w-100 border p-2 position-relative' style={{ height: "70vh", overflow: "scroll" }} >

                                    {productlist?.map(item => {
                                        const isSelected = selectedItems?.some(its => its.id === item.ondc_product_id)
                                        return <>
                                            <div className='w-25 border d-flex' style={{ height: "140px" }}>
                                                <div className='p-1' style={{ width: "30%" }}>
                                                    <img src={item.image} alt="" className='w-100' />
                                                </div>
                                                <div className='text-dark p-1 position-relative '>
                                                    <p className='m-0' style={{ fontSize: "13px" }}>{item?.name?.length > 50 ? `${item?.name?.substring(0, 50)}...` : item.name}</p>
                                                    <p className='m-0' style={{ fontSize: "13px" }}>category: {item?.product_type_name}</p>
                                                    {/* <p className='m-0' style={{ fontSize: "13px" }}>category: {item?.name?.length}</p> */}
                                                    <p className='m-0' style={{ fontSize: "13px" }}>mrp : {item?.mrp}</p>
                                                    <p className='m-0' style={{ fontSize: "13px" }}>price:{item?.selling_price}</p>
                                                    <div className='d-flex justify-content-between align-items-center w-100'>
                                                        <p className='m-0' style={{ fontSize: "13px" }}>qty:{item?.quantity}</p>
                                                        {/* <p className='m-0' style={{ fontSize: "13px" }}>{item?.status ? "Active" : "Inactive"}</p> */}
                                                        <Badge
                                                            color={item?.status ? "green" : "gold"}
                                                            text={item?.status ? "Active" : "Inactive"}
                                                        />
                                                    </div>

                                                    <input type="checkbox" checked={isSelected ? true : false} className='position-absolute' style={{ top: "5px", right: "5px" }} onChange={() => { onSelectProduct(item.ondc_product_id) }} />

                                                </div>

                                            </div>

                                        </>
                                    })}

                                    {selectedItems?.length > 0 && <div className='position-fixed' style={{ bottom: "50px", left: "50%" }}>

                                        <button className='btn btn-primary' style={{ borderRadius: "20px" }} onClick={showModal}> configure price</button>

                                    </div>}



                                </div>}

                                {
                                    productisLoading && <>
                                        <div className='w-100 h-100 d-flex justify-content-center align-items-center text-dark '>
                                            <p className='mt-4'> Please wait while we load your products...</p>
                                        </div>
                                    </>
                                }
                            </div>

                            </>

                            }



                        </div>
                    </div>


                    <Modal
                        title="configure price for buyer apps"
                        closable={{ 'aria-label': 'Custom Close Button' }}
                        open={isModalOpen}
                        onOk={handleOk}
                        onCancel={handleCancel}
                        style={{ height: "200px" }}
                    >
                        <div className="my-1">
                            <p className='m-0'>Enter flat amount value</p>
                            <Input placeholder="" value={formmData?.flat} onChange={(e) => { setFormData((prev) => { return { ...prev, flat: e.target.value } }) }} />
                        </div>
                        <div className="my-1">
                            <p className='m-0'>Enter percent commission value</p>
                            <Input placeholder="" value={formmData?.percent} onChange={(e) => { setFormData((prev) => { return { ...prev, percent: e.target.value } }) }} />
                        </div>

                        <div className='my-1'>
                            <p className='m-0'>Select buyer apps</p>
                            <Select
                                mode="multiple"
                                style={{ width: '100%' }}
                                placeholder="Please select buyer app"
                                // defaultValue={['happy']}
                                onChange={(value) =>
                                    setFormData(prev => ({ ...prev, bnp: value }))
                                }
                                options={options}
                                optionRender={(option) => (
                                    <Space>
                                        <span role="img" aria-label={option.data.label}>
                                            {option.data.emoji}
                                        </span>
                                        {`${option.data.label} (${option.data.desc})`}
                                    </Space>
                                )}
                                value={formmData?.bnp}
                            />
                        </div>
                        {choosenMethod === "category" &&
                            < div className='my-1'>
                                <p className='m-0'>Select categories</p>
                                <Select
                                    mode="multiple"
                                    style={{ width: '100%' }}
                                    placeholder="Please select categories"
                                    // defaultValue={['happy']}
                                    onChange={(value) =>
                                        setFormData(prev => ({ ...prev, category: value }))
                                    }
                                    options={[...new Set(productlist.map(item => item.product_type_name))]?.map(name => ({
                                        label: name,
                                        value: name
                                    }))}
                                    optionRender={(option) => {
                                        console.log("optopns0000", option)
                                        return <Space>
                                            {/* <span role="img" aria-label={option.data.label}>
                                            {option.data.emoji}
                                        </span> */}
                                            {`${option.data.product_type_name} (${option.data.product_type_name})`}
                                        </Space>
                                    }}
                                    value={formmData?.category}
                                />
                            </div>
                        }
                    </Modal>


                </div>
            </div >
        </ThemeMaker >
    )
}
